var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStartOp = function SvgStartOp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 54 54"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "currentColor",
    rx: 27
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.48 32.814V20.244c0-1.037.625-1.547 1.363-1.547.316 0 .659.097.975.282l10.494 6.117c.783.457 1.126.835 1.126 1.432 0 .598-.343.976-1.126 1.433l-10.494 6.117c-.316.185-.659.281-.975.281-.738 0-1.363-.51-1.363-1.547"
  })));
};
export default SvgStartOp;